/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddHours200,
  AddWeekReportActivity200,
  AddWeekReportActivityRequest,
  AddWeekReportHourRequest,
  ApproveWeekReport200,
  CreateCorrection200,
  CreateWeekReport200,
  CreateWeekReportRequest,
  DeleteAttachment200,
  DeleteWeekReport200,
  GenerateWeekReport200,
  GenerateWeekReportRequest,
  GetWeekReport200,
  GetWeekReportHistory200,
  MarkInReview200,
  PagedResponseWeekReport,
  RejectWeekReport200,
  RejectWeekReportRequest,
  RemoveWeekReportActivity200,
  SearchWeekReportsParams,
  StartReview200,
  Submit200,
  UpdateWeekReport200,
  UpdateWeekReportRequest,
  UploadAttachment200,
  UploadAttachmentBody,
  UploadAttachmentParams,
  WeekReport,
  WeekReportAttachment,
  WeekReportHour,
  WeekReportLine
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List week reports for the caller's organisation
 */
export const listWeekReports = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<WeekReport[]>(
      {url: `/api/v1/week-reports`, method: 'GET', signal
    },
      );
    }
  



export const getListWeekReportsQueryKey = () => {
    return [
    `/api/v1/week-reports`
    ] as const;
    }

    
export const getListWeekReportsQueryOptions = <TData = Awaited<ReturnType<typeof listWeekReports>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWeekReportsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWeekReports>>> = ({ signal }) => listWeekReports(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWeekReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWeekReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listWeekReports>>>
export type ListWeekReportsQueryError = unknown


export function useListWeekReports<TData = Awaited<ReturnType<typeof listWeekReports>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWeekReports>>,
          TError,
          Awaited<ReturnType<typeof listWeekReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWeekReports<TData = Awaited<ReturnType<typeof listWeekReports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWeekReports>>,
          TError,
          Awaited<ReturnType<typeof listWeekReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWeekReports<TData = Awaited<ReturnType<typeof listWeekReports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List week reports for the caller's organisation
 */

export function useListWeekReports<TData = Awaited<ReturnType<typeof listWeekReports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReports>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWeekReportsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a week report draft for a contract
 */
export const createWeekReport = (
    createWeekReportRequest: CreateWeekReportRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateWeekReport200>(
      {url: `/api/v1/week-reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWeekReportRequest, signal
    },
      );
    }
  


export const getCreateWeekReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWeekReport>>, TError,{data: CreateWeekReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWeekReport>>, TError,{data: CreateWeekReportRequest}, TContext> => {

const mutationKey = ['createWeekReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWeekReport>>, {data: CreateWeekReportRequest}> = (props) => {
          const {data} = props ?? {};

          return  createWeekReport(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWeekReportMutationResult = NonNullable<Awaited<ReturnType<typeof createWeekReport>>>
    export type CreateWeekReportMutationBody = CreateWeekReportRequest
    export type CreateWeekReportMutationError = unknown

    /**
 * @summary Create a week report draft for a contract
 */
export const useCreateWeekReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWeekReport>>, TError,{data: CreateWeekReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWeekReport>>,
        TError,
        {data: CreateWeekReportRequest},
        TContext
      > => {

      const mutationOptions = getCreateWeekReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Send the week report to the client — partner only; creates or updates the client's copy
 */
export const submit = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Submit200>(
      {url: `/api/v1/week-reports/${id}/submit`, method: 'POST', signal
    },
      );
    }
  


export const getSubmitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submit>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submit>>, TError,{id: string}, TContext> => {

const mutationKey = ['submit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  submit(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitMutationResult = NonNullable<Awaited<ReturnType<typeof submit>>>
    
    export type SubmitMutationError = unknown

    /**
 * @summary Send the week report to the client — partner only; creates or updates the client's copy
 */
export const useSubmit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submit>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submit>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSubmitMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Client marks a submitted week report as under review — own copy only
 */
export const startReview = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<StartReview200>(
      {url: `/api/v1/week-reports/${id}/start-review`, method: 'POST', signal
    },
      );
    }
  


export const getStartReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startReview>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startReview>>, TError,{id: string}, TContext> => {

const mutationKey = ['startReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startReview>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  startReview(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartReviewMutationResult = NonNullable<Awaited<ReturnType<typeof startReview>>>
    
    export type StartReviewMutationError = unknown

    /**
 * @summary Client marks a submitted week report as under review — own copy only
 */
export const useStartReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startReview>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startReview>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getStartReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Client rejects with a reason — partner corrects via /correction afterwards
 */
export const rejectWeekReport = (
    id: string,
    rejectWeekReportRequest: RejectWeekReportRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RejectWeekReport200>(
      {url: `/api/v1/week-reports/${id}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectWeekReportRequest, signal
    },
      );
    }
  


export const getRejectWeekReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectWeekReport>>, TError,{id: string;data: RejectWeekReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectWeekReport>>, TError,{id: string;data: RejectWeekReportRequest}, TContext> => {

const mutationKey = ['rejectWeekReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectWeekReport>>, {id: string;data: RejectWeekReportRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectWeekReport(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectWeekReportMutationResult = NonNullable<Awaited<ReturnType<typeof rejectWeekReport>>>
    export type RejectWeekReportMutationBody = RejectWeekReportRequest
    export type RejectWeekReportMutationError = unknown

    /**
 * @summary Client rejects with a reason — partner corrects via /correction afterwards
 */
export const useRejectWeekReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectWeekReport>>, TError,{id: string;data: RejectWeekReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectWeekReport>>,
        TError,
        {id: string;data: RejectWeekReportRequest},
        TContext
      > => {

      const mutationOptions = getRejectWeekReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Partner marks a draft as internally reviewed — required before submit()
 */
export const markInReview = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<MarkInReview200>(
      {url: `/api/v1/week-reports/${id}/mark-in-review`, method: 'POST', signal
    },
      );
    }
  


export const getMarkInReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInReview>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markInReview>>, TError,{id: string}, TContext> => {

const mutationKey = ['markInReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markInReview>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  markInReview(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkInReviewMutationResult = NonNullable<Awaited<ReturnType<typeof markInReview>>>
    
    export type MarkInReviewMutationError = unknown

    /**
 * @summary Partner marks a draft as internally reviewed — required before submit()
 */
export const useMarkInReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markInReview>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markInReview>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMarkInReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List a week report's logged hours (partner-only, never sent to client)
 */
export const listHours = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<WeekReportHour[]>(
      {url: `/api/v1/week-reports/${id}/hours`, method: 'GET', signal
    },
      );
    }
  



export const getListHoursQueryKey = (id?: string,) => {
    return [
    `/api/v1/week-reports/${id}/hours`
    ] as const;
    }

    
export const getListHoursQueryOptions = <TData = Awaited<ReturnType<typeof listHours>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHours>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHoursQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHours>>> = ({ signal }) => listHours(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHours>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListHoursQueryResult = NonNullable<Awaited<ReturnType<typeof listHours>>>
export type ListHoursQueryError = unknown


export function useListHours<TData = Awaited<ReturnType<typeof listHours>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHours>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHours>>,
          TError,
          Awaited<ReturnType<typeof listHours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListHours<TData = Awaited<ReturnType<typeof listHours>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHours>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHours>>,
          TError,
          Awaited<ReturnType<typeof listHours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListHours<TData = Awaited<ReturnType<typeof listHours>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHours>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a week report's logged hours (partner-only, never sent to client)
 */

export function useListHours<TData = Awaited<ReturnType<typeof listHours>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHours>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListHoursQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Log hours for a user against a week report
 */
export const addHours = (
    id: string,
    addWeekReportHourRequest: AddWeekReportHourRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddHours200>(
      {url: `/api/v1/week-reports/${id}/hours`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addWeekReportHourRequest, signal
    },
      );
    }
  


export const getAddHoursMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addHours>>, TError,{id: string;data: AddWeekReportHourRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addHours>>, TError,{id: string;data: AddWeekReportHourRequest}, TContext> => {

const mutationKey = ['addHours'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addHours>>, {id: string;data: AddWeekReportHourRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addHours(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddHoursMutationResult = NonNullable<Awaited<ReturnType<typeof addHours>>>
    export type AddHoursMutationBody = AddWeekReportHourRequest
    export type AddHoursMutationError = unknown

    /**
 * @summary Log hours for a user against a week report
 */
export const useAddHours = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addHours>>, TError,{id: string;data: AddWeekReportHourRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addHours>>,
        TError,
        {id: string;data: AddWeekReportHourRequest},
        TContext
      > => {

      const mutationOptions = getAddHoursMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Partner creates a correction of a REJECTED week report — new row, linked via correctedFrom
 */
export const createCorrection = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateCorrection200>(
      {url: `/api/v1/week-reports/${id}/correction`, method: 'POST', signal
    },
      );
    }
  


export const getCreateCorrectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCorrection>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCorrection>>, TError,{id: string}, TContext> => {

const mutationKey = ['createCorrection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCorrection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  createCorrection(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCorrectionMutationResult = NonNullable<Awaited<ReturnType<typeof createCorrection>>>
    
    export type CreateCorrectionMutationError = unknown

    /**
 * @summary Partner creates a correction of a REJECTED week report — new row, linked via correctedFrom
 */
export const useCreateCorrection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCorrection>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCorrection>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCreateCorrectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List a week report's attachments
 */
export const listAttachments = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<WeekReportAttachment[]>(
      {url: `/api/v1/week-reports/${id}/attachments`, method: 'GET', signal
    },
      );
    }
  



export const getListAttachmentsQueryKey = (id?: string,) => {
    return [
    `/api/v1/week-reports/${id}/attachments`
    ] as const;
    }

    
export const getListAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAttachmentsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAttachments>>> = ({ signal }) => listAttachments(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAttachments>>>
export type ListAttachmentsQueryError = unknown


export function useListAttachments<TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAttachments>>,
          TError,
          Awaited<ReturnType<typeof listAttachments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAttachments<TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAttachments>>,
          TError,
          Awaited<ReturnType<typeof listAttachments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAttachments<TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a week report's attachments
 */

export function useListAttachments<TData = Awaited<ReturnType<typeof listAttachments>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAttachmentsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Upload an attachment — partner only; visible-to-client copy is created immediately if flagged
 */
export const uploadAttachment = (
    id: string,
    uploadAttachmentBody: UploadAttachmentBody,
    params?: UploadAttachmentParams,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, uploadAttachmentBody.file)

      return apiClient<UploadAttachment200>(
      {url: `/api/v1/week-reports/${id}/attachments`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params, signal
    },
      );
    }
  


export const getUploadAttachmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAttachment>>, TError,{id: string;data: UploadAttachmentBody;params?: UploadAttachmentParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadAttachment>>, TError,{id: string;data: UploadAttachmentBody;params?: UploadAttachmentParams}, TContext> => {

const mutationKey = ['uploadAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAttachment>>, {id: string;data: UploadAttachmentBody;params?: UploadAttachmentParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  uploadAttachment(id,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAttachment>>>
    export type UploadAttachmentMutationBody = UploadAttachmentBody
    export type UploadAttachmentMutationError = unknown

    /**
 * @summary Upload an attachment — partner only; visible-to-client copy is created immediately if flagged
 */
export const useUploadAttachment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAttachment>>, TError,{id: string;data: UploadAttachmentBody;params?: UploadAttachmentParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadAttachment>>,
        TError,
        {id: string;data: UploadAttachmentBody;params?: UploadAttachmentParams},
        TContext
      > => {

      const mutationOptions = getUploadAttachmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Client approves — locks both copies and syncs contract_lines.realized_qty
 */
export const approveWeekReport = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ApproveWeekReport200>(
      {url: `/api/v1/week-reports/${id}/approve`, method: 'POST', signal
    },
      );
    }
  


export const getApproveWeekReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveWeekReport>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveWeekReport>>, TError,{id: string}, TContext> => {

const mutationKey = ['approveWeekReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveWeekReport>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  approveWeekReport(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveWeekReportMutationResult = NonNullable<Awaited<ReturnType<typeof approveWeekReport>>>
    
    export type ApproveWeekReportMutationError = unknown

    /**
 * @summary Client approves — locks both copies and syncs contract_lines.realized_qty
 */
export const useApproveWeekReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveWeekReport>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveWeekReport>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getApproveWeekReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Add one unlocked Activity (same contract/week/year) into this week report and re-aggregate
 */
export const addWeekReportActivity = (
    id: string,
    addWeekReportActivityRequest: AddWeekReportActivityRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddWeekReportActivity200>(
      {url: `/api/v1/week-reports/${id}/activities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addWeekReportActivityRequest, signal
    },
      );
    }
  


export const getAddWeekReportActivityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWeekReportActivity>>, TError,{id: string;data: AddWeekReportActivityRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addWeekReportActivity>>, TError,{id: string;data: AddWeekReportActivityRequest}, TContext> => {

const mutationKey = ['addWeekReportActivity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addWeekReportActivity>>, {id: string;data: AddWeekReportActivityRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addWeekReportActivity(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddWeekReportActivityMutationResult = NonNullable<Awaited<ReturnType<typeof addWeekReportActivity>>>
    export type AddWeekReportActivityMutationBody = AddWeekReportActivityRequest
    export type AddWeekReportActivityMutationError = unknown

    /**
 * @summary Add one unlocked Activity (same contract/week/year) into this week report and re-aggregate
 */
export const useAddWeekReportActivity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWeekReportActivity>>, TError,{id: string;data: AddWeekReportActivityRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addWeekReportActivity>>,
        TError,
        {id: string;data: AddWeekReportActivityRequest},
        TContext
      > => {

      const mutationOptions = getAddWeekReportActivityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Aggregate unlocked Activities for a contract+week into a draft/in-review week report
 */
export const generateWeekReport = (
    generateWeekReportRequest: GenerateWeekReportRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GenerateWeekReport200>(
      {url: `/api/v1/week-reports/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateWeekReportRequest, signal
    },
      );
    }
  


export const getGenerateWeekReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateWeekReport>>, TError,{data: GenerateWeekReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateWeekReport>>, TError,{data: GenerateWeekReportRequest}, TContext> => {

const mutationKey = ['generateWeekReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateWeekReport>>, {data: GenerateWeekReportRequest}> = (props) => {
          const {data} = props ?? {};

          return  generateWeekReport(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateWeekReportMutationResult = NonNullable<Awaited<ReturnType<typeof generateWeekReport>>>
    export type GenerateWeekReportMutationBody = GenerateWeekReportRequest
    export type GenerateWeekReportMutationError = unknown

    /**
 * @summary Aggregate unlocked Activities for a contract+week into a draft/in-review week report
 */
export const useGenerateWeekReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateWeekReport>>, TError,{data: GenerateWeekReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateWeekReport>>,
        TError,
        {data: GenerateWeekReportRequest},
        TContext
      > => {

      const mutationOptions = getGenerateWeekReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single week report
 */
export const getWeekReport = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetWeekReport200>(
      {url: `/api/v1/week-reports/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetWeekReportQueryKey = (id?: string,) => {
    return [
    `/api/v1/week-reports/${id}`
    ] as const;
    }

    
export const getGetWeekReportQueryOptions = <TData = Awaited<ReturnType<typeof getWeekReport>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWeekReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeekReport>>> = ({ signal }) => getWeekReport(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWeekReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWeekReportQueryResult = NonNullable<Awaited<ReturnType<typeof getWeekReport>>>
export type GetWeekReportQueryError = unknown


export function useGetWeekReport<TData = Awaited<ReturnType<typeof getWeekReport>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWeekReport>>,
          TError,
          Awaited<ReturnType<typeof getWeekReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeekReport<TData = Awaited<ReturnType<typeof getWeekReport>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWeekReport>>,
          TError,
          Awaited<ReturnType<typeof getWeekReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeekReport<TData = Awaited<ReturnType<typeof getWeekReport>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single week report
 */

export function useGetWeekReport<TData = Awaited<ReturnType<typeof getWeekReport>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReport>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWeekReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a week report — only while not yet sent to the client; unlocks its Activities
 */
export const deleteWeekReport = (
    id: string,
 ) => {
      
      
      return apiClient<DeleteWeekReport200>(
      {url: `/api/v1/week-reports/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteWeekReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWeekReport>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWeekReport>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteWeekReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWeekReport>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWeekReport(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWeekReportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWeekReport>>>
    
    export type DeleteWeekReportMutationError = unknown

    /**
 * @summary Delete a week report — only while not yet sent to the client; unlocks its Activities
 */
export const useDeleteWeekReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWeekReport>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWeekReport>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteWeekReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a week report's team — only while DRAFT/IN_REVIEW/CORRECTED
 */
export const updateWeekReport = (
    id: string,
    updateWeekReportRequest: UpdateWeekReportRequest,
 ) => {
      
      
      return apiClient<UpdateWeekReport200>(
      {url: `/api/v1/week-reports/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateWeekReportRequest
    },
      );
    }
  


export const getUpdateWeekReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWeekReport>>, TError,{id: string;data: UpdateWeekReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWeekReport>>, TError,{id: string;data: UpdateWeekReportRequest}, TContext> => {

const mutationKey = ['updateWeekReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWeekReport>>, {id: string;data: UpdateWeekReportRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWeekReport(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWeekReportMutationResult = NonNullable<Awaited<ReturnType<typeof updateWeekReport>>>
    export type UpdateWeekReportMutationBody = UpdateWeekReportRequest
    export type UpdateWeekReportMutationError = unknown

    /**
 * @summary Update a week report's team — only while DRAFT/IN_REVIEW/CORRECTED
 */
export const useUpdateWeekReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWeekReport>>, TError,{id: string;data: UpdateWeekReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWeekReport>>,
        TError,
        {id: string;data: UpdateWeekReportRequest},
        TContext
      > => {

      const mutationOptions = getUpdateWeekReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List a week report's lines
 */
export const listWeekReportLines = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<WeekReportLine[]>(
      {url: `/api/v1/week-reports/${id}/lines`, method: 'GET', signal
    },
      );
    }
  



export const getListWeekReportLinesQueryKey = (id?: string,) => {
    return [
    `/api/v1/week-reports/${id}/lines`
    ] as const;
    }

    
export const getListWeekReportLinesQueryOptions = <TData = Awaited<ReturnType<typeof listWeekReportLines>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportLines>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWeekReportLinesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWeekReportLines>>> = ({ signal }) => listWeekReportLines(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWeekReportLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWeekReportLinesQueryResult = NonNullable<Awaited<ReturnType<typeof listWeekReportLines>>>
export type ListWeekReportLinesQueryError = unknown


export function useListWeekReportLines<TData = Awaited<ReturnType<typeof listWeekReportLines>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWeekReportLines>>,
          TError,
          Awaited<ReturnType<typeof listWeekReportLines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWeekReportLines<TData = Awaited<ReturnType<typeof listWeekReportLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWeekReportLines>>,
          TError,
          Awaited<ReturnType<typeof listWeekReportLines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWeekReportLines<TData = Awaited<ReturnType<typeof listWeekReportLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportLines>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a week report's lines
 */

export function useListWeekReportLines<TData = Awaited<ReturnType<typeof listWeekReportLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportLines>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWeekReportLinesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary AUD-01/AUD-02: header change history for this week report copy (not line/hour changes)
 */
export const getWeekReportHistory = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetWeekReportHistory200>(
      {url: `/api/v1/week-reports/${id}/history`, method: 'GET', signal
    },
      );
    }
  



export const getGetWeekReportHistoryQueryKey = (id?: string,) => {
    return [
    `/api/v1/week-reports/${id}/history`
    ] as const;
    }

    
export const getGetWeekReportHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getWeekReportHistory>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReportHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWeekReportHistoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeekReportHistory>>> = ({ signal }) => getWeekReportHistory(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWeekReportHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWeekReportHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getWeekReportHistory>>>
export type GetWeekReportHistoryQueryError = unknown


export function useGetWeekReportHistory<TData = Awaited<ReturnType<typeof getWeekReportHistory>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReportHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWeekReportHistory>>,
          TError,
          Awaited<ReturnType<typeof getWeekReportHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeekReportHistory<TData = Awaited<ReturnType<typeof getWeekReportHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReportHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWeekReportHistory>>,
          TError,
          Awaited<ReturnType<typeof getWeekReportHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWeekReportHistory<TData = Awaited<ReturnType<typeof getWeekReportHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReportHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary AUD-01/AUD-02: header change history for this week report copy (not line/hour changes)
 */

export function useGetWeekReportHistory<TData = Awaited<ReturnType<typeof getWeekReportHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWeekReportHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWeekReportHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Paginated, filterable week report list for the main Week Reports list page
 */
export const searchWeekReports = (
    params?: SearchWeekReportsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseWeekReport>(
      {url: `/api/v1/week-reports/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchWeekReportsQueryKey = (params?: SearchWeekReportsParams,) => {
    return [
    `/api/v1/week-reports/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchWeekReportsQueryOptions = <TData = Awaited<ReturnType<typeof searchWeekReports>>, TError = unknown>(params?: SearchWeekReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWeekReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchWeekReportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchWeekReports>>> = ({ signal }) => searchWeekReports(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchWeekReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchWeekReportsQueryResult = NonNullable<Awaited<ReturnType<typeof searchWeekReports>>>
export type SearchWeekReportsQueryError = unknown


export function useSearchWeekReports<TData = Awaited<ReturnType<typeof searchWeekReports>>, TError = unknown>(
 params: undefined |  SearchWeekReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWeekReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchWeekReports>>,
          TError,
          Awaited<ReturnType<typeof searchWeekReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchWeekReports<TData = Awaited<ReturnType<typeof searchWeekReports>>, TError = unknown>(
 params?: SearchWeekReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWeekReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchWeekReports>>,
          TError,
          Awaited<ReturnType<typeof searchWeekReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchWeekReports<TData = Awaited<ReturnType<typeof searchWeekReports>>, TError = unknown>(
 params?: SearchWeekReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWeekReports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable week report list for the main Week Reports list page
 */

export function useSearchWeekReports<TData = Awaited<ReturnType<typeof searchWeekReports>>, TError = unknown>(
 params?: SearchWeekReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchWeekReports>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchWeekReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete an attachment (own copy only)
 */
export const deleteAttachment = (
    id: string,
    attachmentId: string,
 ) => {
      
      
      return apiClient<DeleteAttachment200>(
      {url: `/api/v1/week-reports/${id}/attachments/${attachmentId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAttachmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{id: string;attachmentId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{id: string;attachmentId: string}, TContext> => {

const mutationKey = ['deleteAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttachment>>, {id: string;attachmentId: string}> = (props) => {
          const {id,attachmentId} = props ?? {};

          return  deleteAttachment(id,attachmentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttachment>>>
    
    export type DeleteAttachmentMutationError = unknown

    /**
 * @summary Delete an attachment (own copy only)
 */
export const useDeleteAttachment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{id: string;attachmentId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttachment>>,
        TError,
        {id: string;attachmentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteAttachmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Remove an Activity from this week report (unlocks it) and re-aggregate
 */
export const removeWeekReportActivity = (
    id: string,
    activityId: string,
 ) => {
      
      
      return apiClient<RemoveWeekReportActivity200>(
      {url: `/api/v1/week-reports/${id}/activities/${activityId}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveWeekReportActivityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeWeekReportActivity>>, TError,{id: string;activityId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeWeekReportActivity>>, TError,{id: string;activityId: string}, TContext> => {

const mutationKey = ['removeWeekReportActivity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeWeekReportActivity>>, {id: string;activityId: string}> = (props) => {
          const {id,activityId} = props ?? {};

          return  removeWeekReportActivity(id,activityId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveWeekReportActivityMutationResult = NonNullable<Awaited<ReturnType<typeof removeWeekReportActivity>>>
    
    export type RemoveWeekReportActivityMutationError = unknown

    /**
 * @summary Remove an Activity from this week report (unlocks it) and re-aggregate
 */
export const useRemoveWeekReportActivity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeWeekReportActivity>>, TError,{id: string;activityId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeWeekReportActivity>>,
        TError,
        {id: string;activityId: string},
        TContext
      > => {

      const mutationOptions = getRemoveWeekReportActivityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    